import { Component, OnInit, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import TaskList = gapi.client.tasks.TaskList;

import { runInAngular } from '../run-in-angular';
import { StoreService } from '../store.service';
import { TasklistsDeleteParams, TasklistsInsertParams, TasklistsPatchParams } from '../api/tasklists-resource-method-params';
import { NameDialogComponent } from '../name-dialog/name-dialog.component';

const DEBUG = false;

@Component({
  selector: 'app-tasklists',
  templateUrl: './tasklists.component.html',
  styleUrls: ['./tasklists.component.scss']
})
export class TaskListsComponent implements OnInit {

  // taskLists$ = new Subject<TaskLists>();
  // subscription?: Subscription;
  taskListArray$?: Observable<TaskList[]>;

  constructor(
    private store: StoreService,
    private ngZone: NgZone,
    private addDialog: MatDialog,
    private renameDialog: MatDialog) {
    if (DEBUG) {console.log('new TaskListsComponent()');}
  }

  ngOnInit(): void {
    if (DEBUG) {console.log('TaskListsComponent onInit()');}
    this.taskListArray$ = this.store.taskLists$.pipe(map(taskList => {
      return taskList.items ? taskList.items : []
    }), runInAngular(this.ngZone));
  }

  onSelect(selection: TaskList): void {
    if(DEBUG) {console.log('selecting TaskList: %o', selection);}
    this.store.onTaskListSelected(selection);
  }

  add(): void {
    const dialogRef = this.addDialog.open(NameDialogComponent, {
      width: '600px',
      data: undefined
    });
    dialogRef.afterClosed().subscribe((data) => {
      const taskList: TaskList = {title: data};
      const params: TasklistsInsertParams = {resource: taskList};
      this.store.onTaskListAdded(params);
    });
  }

  rename(selection: TaskList): void {
    const dialogRef = this.renameDialog.open(NameDialogComponent, {
      width: '600px',
      data: selection.title
    });
    dialogRef.afterClosed().subscribe((data) => {
      const params: TasklistsPatchParams = {
        tasklist: selection.id!, // eslint-disable-line @typescript-eslint/no-non-null-assertion
        resource: {title: data}
      };
      this.store.onTaskListUpdated(params);
    });
  }

  delete(selection: TaskList): void {
    if(DEBUG) {console.log('deleting TaskList: %o', selection);}
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const params: TasklistsDeleteParams = {tasklist: selection.id!};
    void this.store.onTaskListDeleted(params);
  }
}
